/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Insights_Lpprofile_Empty_Subtitle2Inputs */

const en_coinvestments_insights_lpprofile_empty_subtitle2 = /** @type {(inputs: Coinvestments_Insights_Lpprofile_Empty_Subtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insights will appear once this organisation has co-investment activity`)
};

/**
* | output |
* | --- |
* | "Insights will appear once this organisation has co-investment activity" |
*
* @param {Coinvestments_Insights_Lpprofile_Empty_Subtitle2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_insights_lpprofile_empty_subtitle2 = /** @type {((inputs?: Coinvestments_Insights_Lpprofile_Empty_Subtitle2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Insights_Lpprofile_Empty_Subtitle2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_insights_lpprofile_empty_subtitle2(inputs)
});
export { coinvestments_insights_lpprofile_empty_subtitle2 as "coInvestments_insights_lpProfile_empty_subtitle" }